import { useState, useEffect, useCallback } from "react";
import { usePoll } from "@/hooks/usePoll";
import { getRetentionQueue, type RetentionItem } from "../api/client";

const POLL_INTERVAL_MS = 30_000;

export interface UseRetentionQueueResult {
  items: RetentionItem[];
  isLoading: boolean;
  error: string | null;
  refresh: () => void;
}

export function useRetentionQueue(jobTypeId?: string): UseRetentionQueueResult {
  const [items, setItems] = useState<RetentionItem[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const refresh = useCallback(async () => {
    setError(null);
    try {
      const data = await getRetentionQueue(jobTypeId);
      setItems(data);
    } catch (e) {
      setError(e instanceof Error ? e.message : "Failed to load retention queue");
    } finally {
      setIsLoading(false);
    }
  }, [jobTypeId]);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  usePoll(refresh, POLL_INTERVAL_MS);

  return { items, isLoading, error, refresh };
}
